<div>
  <form [formGroup]="form">
    <div class="fields-container">
      <!-- Mode selector -->
      @if (!viewProductList && !isGSPCertificate && !isPersonalUse) {
        @if(mode == 'add') {
          <div class="field-control">
            <app-boolean
              [label]="'PRODUCT_FORM.HOW_ADD_Q' | translate"
              [control]="form.get('mode')"
              [options]="[
                {
                  value: 'manual',
                  label: ('PRODUCT_FORM.ADD_MANUAL' | translate)
                },
                { value: 'bulk', label: ('PRODUCT_FORM.ADD_BULK' | translate) }
              ]"
              (onSelectionChange)="onAddProductChange($event)"
            ></app-boolean>
          </div>
        }
      }
    </div>
    <!-- MANUAL BLOCK -->
    @if (manual) {
    <div id="product-form">
      @if(!isGSPCertificate && !isPersonalUse){
         @if(mode == 'add') {
          <h1 class="section-heading">
            {{ "PRODUCT_FORM.MANUAL_TITLE" | translate }}
          </h1>
        }
      }
      <div class="fields-container">
        @if(isPersonalUse){
        <div class="field-control">
          <app-option-field
            [label]="'PRODUCT_FORM.PERSONAL_EFFECT_TYPE' | translate"
            [control]="form.get('cooPersonalEffectType')!"
            [lovType]="lookupKey.COO_DC_PER_EFF_TYPE"
            (onSelectionChange)="getHsCodeForEffectType($event)"
          />
        </div>
        }

        <div class="field-control">
          <app-searchable-list
            [label]="
              serviceName == 'ATA_CARNET'
                ? ('PRODUCT_FORM.PRODUCT_HS_CODE' | translate)
                : ('PRODUCT_FORM.COO_PRODUCT_HS_CODE' | translate)
            "
            [placeholder]="'PRODUCT_FORM.SEARCH_PH' | translate"
            [options]="hsCodeList"
            [control]="form.get('productHSCode')!"
            (onAdd)="onAddItem($event)"
            [loading]="loadingHsCode"
            [noOfTotalRecords]="totalHsRecords"
            [noOfRecordPerPage]="50"
            (onRemove)="onRemoveItem($event)"
            (onPageChange)="fetchNextRecord($event)"
            (search)="handleSearch($event)"
            [showSelectedItemsList]="false"
            [allowAddMultiple]="false"
            [showPageNation]="true"
            (onSelectionClear)="clearHsCode()"
          />
          <!-- @if(!(form.get('productHSCode')?.value) && serviceName !=
          'ATA_CARNET'){
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'PRODUCT_FORM.HS_CODE_INFO' | translate,
              message: 'PRODUCT_FORM.HS_CODE_DESC' | translate
            }"
            [showbutton]="false"
            [buttonText]="'PRODUCT_FORM.HS_CODE_CONTACT' | translate"
            (onBtnClick)="contactUs()"
          ></app-validation-message>
          } -->
        </div>
        @if (serviceName == 'ATA_CARNET') {
        <div class="field-control">
          <app-text-field
            [label]="'PRODUCT_FORM.PRODUCT_NAME' | translate"
            [control]="form.get('productNameEn')!"
            [validationMessages]="{
              english: 'VALIDATION_MSG.EN_LETTERS' | translate
            }"
          />
        </div>
        <div class="field-control">
          <app-text-field
            [label]="'PRODUCT_FORM.PRODUCT_NAME_AR' | translate"
            [control]="form.get('productNameAr')!"
            [validationMessages]="{
              arabic: 'VALIDATION_MSG.AR_LETTERS' | translate
            }"
          />
        </div>
        }

        <div class="field-control">
          <app-option-field
            [label]="'PRODUCT_FORM.UNIT' | translate"
            [control]="form.get('unit')!"
            [lovType]="lookupKey.UNIT_OF_MEASURE"
          />
        </div>
        <div class="field-control">
          <app-text-field
            type="number"
            [label]="'PRODUCT_FORM.QUANTITY' | translate"
            [control]="form.get('quantity')!"
            [validationMessages]="{
              numberOnly: 'VALIDATION_MSG.NUMBER_ONLY' | translate
            }"
          ></app-text-field>
        </div>
        <div class="field-control">
          <app-text-field
            [label]="'PRODUCT_FORM.UNIT_PRICE' | translate"
            [control]="form.get('unitPrice')!"
            [validationMessages]="{
              numberWithDecimal:
                'VALIDATION_MSG.NUMBER_WITH_DECIMAL' | translate
            }"
          ></app-text-field>
        </div>
        @if (serviceName == 'ATA_CARNET') {
        <div class="field-control">
          <app-text-field
            type="number"
            [label]="'PRODUCT_FORM.WEIGHT' | translate"
            [control]="form.get('weight')!"
          ></app-text-field>
        </div>
        }
        <div class="field-control">
          <app-option-field
            [label]="'PRODUCT_FORM.COUNTRY_ORIGIN' | translate"
            [lovType]="lookupKey.COUNTRY"
            [control]="form.get('country')!"
            [country]="true"
          ></app-option-field>
        </div>
        @if (serviceName != 'ATA_CARNET') {
        <div class="field-control">
          <app-option-field
            [label]="'PRODUCT_FORM.PROCESSING_TYPE' | translate"
            [control]="form.get('processingType')!"
            [lovType]="lookupKey.COO_DC_PROCESS_TYPE"
            [valueKey]="'Value'"
            [labelKey]="'Value'"
          ></app-option-field>
        </div>
        <div class="field-control">
          <app-option-field
            [label]="'PRODUCT_FORM.PROCESSING_COUNTRY' | translate"
            [control]="form.get('processingCountry')!"
            [lovType]="lookupKey.COUNTRY"
            [country]="true"
          ></app-option-field>
        </div>
        }

        @if (serviceName == 'ATA_CARNET') {
        <div class="field-control">
          <app-option-field
            [label]="'PRODUCT_FORM.CATEGORY_DESCRIPTION' | translate"
            [control]="form.get('category')!"
            [lovType]="lookupKey.ATA_PRODUCT_CATEGORY"
            [labelKey]="'Description'"
            [valueKey]="'Description'"
          ></app-option-field>
        </div>
        }

        <!-- for COO Personal Use and Type Vehicle -->
        @if (serviceName != 'ATA_CARNET' &&
        this.form.get("cooPersonalEffectType")?.value == fieldValue.VEHICLES || this.form.get("cooPersonalEffectType")?.value == fieldValue.VEHICLES_AR) {
        <div class="field-control">
          <app-text-field
            type="text"
            [label]="'PRODUCT_FORM.COO_VEHICLE_CATEGORY' | translate"
            [control]="form.get('cooVehicleCategory')!"
          ></app-text-field>
        </div>
        <div class="field-control">
          <app-text-field
            type="text"
            [label]="'PRODUCT_FORM.COO_VEHICLE_CHASSIS_NUMBER' | translate"
            [control]="form.get('cooVehicleChassisNumber')!"
          ></app-text-field>
        </div>
        <div class="field-control">
          <app-text-field
            type="text"
            [label]="'PRODUCT_FORM.COO_VEHICLE_COLOR' | translate"
            [control]="form.get('cooVehicleColor')!"
          ></app-text-field>
        </div>
        <div class="field-control">
          <app-text-field
            type="text"
            [label]="'PRODUCT_FORM.COO_VEHICLE_ENGINE_NUMBER' | translate"
            [control]="form.get('cooVehicleEngineNumber')!"
          ></app-text-field>
        </div>
        <div class="field-control">
          <app-text-field
            type="text"
            [label]="'PRODUCT_FORM.COO_VEHICLE_MAKE' | translate"
            [control]="form.get('cooVehicleMake')!"
          ></app-text-field>
        </div>
        <div class="field-control">
          <app-text-field
            type="text"
            [label]="'PRODUCT_FORM.COO_VEHICLE_MODEL' | translate"
            [control]="form.get('cooVehicleModel')!"
          ></app-text-field>
        </div>
        <div class="field-control">
          <app-text-field
            type="text"
            [label]="'PRODUCT_FORM.COO_VEHICLE_SUB_MAKE' | translate"
            [control]="form.get('cooVehicleSubMake')!"
          ></app-text-field>
        </div>
        } 
        <!-- duplicate product with hs code and coo -->
        @if (productDetailsErrorMsg) {
        <div class="mb-2">
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'VALIDATION_MSG.ERROR' | translate,
              message: productDetailsErrorMsg | translate
            }"
            [showbutton]="false"
          ></app-validation-message>
        </div>

        }

        @if(!product){
        <app-button
          [label]="'BUTTONS.ADD' | translate"
          classesName="btn-edge-cut btn-primary-small"
          (onBtnClick)="saveAndAddMore()"
        ></app-button>
        }
      </div>
    </div>
    }

    <!-- BULK BLOCK  -->
    @if (bulk) {
    <div>
      <h1 class="section-heading">
        {{ "PRODUCT_FORM.BULK_TITLE" | translate }}
      </h1>
      <div class="fields-container">
        <!-- help card -->
        <div class="mb-5">
          <app-validation-message
            [type]="'default'"
            [content]="{
              title: 'PRODUCT_FORM.HELP_HEADING' | translate,
              message:  (serviceName == 'COO' ? 'PRODUCT_FORM.COO_HELP_TEXT' : 'PRODUCT_FORM.HELP_TEXT') | translate
            }"
           [showbutton]="false"
            (onBtnClick)="downloadTemplateFile($event)"
            [buttonText]="'PRODUCT_FORM.DOWNLOAD_TEMPLATE' | translate"            
          ></app-validation-message>          
          <!-- [startNewText]="'PRODUCT_FORM.VIEW_TUTORIAL' | translate" -->
        </div>
        <!-- upload -->
        @if (MasterHsCodeList.length > 0) {
        <div class="field-control">
          <app-file
            [title]="'PRODUCT_FORM.UPLOAD_LIST_LABEL' | translate"
            [description]="'PRODUCT_FORM.UPLOAD_NOTE' | translate"
            [attachments]="file"
            (onUploadRemove)="onFileChange($event)"
            (removeFile)="remove()"
            [accept]="'.xlsx'"
            [documentServiceType]="'template'"
          ></app-file>
        </div>
        @if (errorMsg) {
        <div class="mt-2 text-dc-commerce-red font-medium">{{ errorMsg }}</div>
        }
        } @if (MasterHsCodeList.length < 1) {
        <app-skeleton-loader [pingLoder]="true"></app-skeleton-loader>
        } @if (invalidProducts.length) {
        <div class="mt-4">
          <div class="dc-message dc-message-error p-4">
  <div class="space-y-3">
    
    <!-- Title -->
    <p class="text-dc-commerce-red font-semibold text-lg leading-tight">
      {{ "PRODUCT_FORM.UPLOAD_VALIDATION_ERRORS" | translate }}
      <span class="text-dc-commerce-red text-base"> ({{ invalidProducts.length }})</span>
    </p>

    <!-- Error List -->
    <ul class="list-disc ms-6 space-y-2 text-sm leading-relaxed text-dc-commerce-red">
      @for (err of invalidProducts; track $index) {
        <li class="mt-1">
         <b> {{ "PRODUCT_FORM.UPLOAD_ROW" | translate }} {{ err.row }}
          ({{ "PRODUCT_FORM.UPLOAD_HS_CODE" | translate }}: {{ err.hsCode }}) -
          </b>
          @if (err.type === 'invalidHSCode') {
            <span class="font-medium text-dc-commerce-red">
              {{ "PRODUCT_FORM.UPLOAD_INVALID_HS_CODE" | translate }}
            </span>
          }

          @if (err.type === 'missingField' && err.missing) {
            <span class="font-medium text-dc-commerce-red">
              {{ "PRODUCT_FORM.UPLOAD_MISSING_VALUE" | translate }}
              @for (label of missingLabels(err.missing); track $index) {
                {{ label }},
              }
            </span>
          }

          @if (err.type === 'invalidLookupValue' && err.invalidFields?.length) {
            <span class="font-medium text-dc-commerce-red" [innerHTML]="'PRODUCT_FORM.INVALID_COLOUMN_VALUE' | translate : {fieldName: err.invalidFields.join(', ')}">
             </span>
          }

          @if (err.type === 'duplicateCombination') {
            <span class="font-medium text-dc-commerce-red">
              {{
                err.message ||
                  "Duplicate HS Code and Country of Origin combination already exists."
                  | translate
              }}
            </span>
          }
        </li>
      }
    </ul>

  </div>
</div>

        </div>
        }
      </div>
    </div>
    }

    <!-- Added product list -->
    @if (manual || viewProductList) {
    <div class="fields-container" id="product-list">
      @for (p of allProducts; track p; let i = $index) {

      <div class="card-edge-cut relative border-blue">
        <div class="card-body bg-dc-blue/5 text-dc-navy">
          <p class="text-dc-navy! font-semibold">{{ p.productNameEn }}</p>
          <div class="grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-4">
            <div>
              <p class="text-xs sm:text-sm text-dc-navy!">
                {{ "PRODUCT_LIST.HS_CODE" | translate }}
              </p>
              <p class="font-semibold text-dc-navy!">
                {{ p.productHSCode ? p.productHSCode : "-" }}
              </p>
              <p class="mt-3 text-xs sm:text-sm text-dc-navy!">
                {{ "PRODUCT_LIST.UNIT_PRICE" | translate }}
              </p>
              <p class="font-semibold text-dc-navy!">
                {{ p.unitPrice | number : "1.2-2" }}
              </p>
            </div>
            <div>
              <p class="text-xs sm:text-sm text-dc-navy!">
                {{ "PRODUCT_LIST.COUNTRY_OF_ORIGIN" | translate }}
              </p>
              <p class="font-semibold text-dc-navy!">{{ p.country }}</p>
              <p class="mt-3 text-xs sm:text-sm text-dc-navy!">
                {{ "PRODUCT_LIST.MEASUREMENT_UNIT" | translate }}
              </p>
              <p class="font-semibold text-dc-navy!">{{ p.unit }}</p>
            </div>

            <div>
              <p class="text-xs sm:text-sm text-dc-navy!">
                {{ "PRODUCT_LIST.QUANTITY" | translate }}
              </p>
              <p class="font-semibold text-dc-navy!">
                {{ p.quantity | number }}
              </p>
              <p class="mt-3 text-xs sm:text-sm text-dc-navy!">
                {{ "PRODUCT_LIST.WEIGHT" | translate }}
              </p>
              <p class="font-semibold text-dc-navy!">
                {{ p.weight | number }}
              </p>
            </div>
            <!-- action cols -->
            @if (allowProductActions) {
            <div class="flex gap-4 text-dc-navy mb-3 justify-center sm:mb-0">
              <button class="font-semibold underline" (click)="editProduct(p)">
                {{ "BUTTONS.EDIT" | translate }}
              </button>
              <button
                class="hover:text-red-600 text-lg leading-none"
                (click)="removeProduct(p)"
                aria-label="Remove"
              >
                <i class="fas fa-remove"></i>
              </button>
            </div>
            }
          </div>
          @if (serviceName == 'ATA_CARNET' && isProductIncomplete(p)) {
          <div class="mt-3 text-red-600 font-medium">
           {{'PRODUCT_FORM.MSG_MISSING_DETAILS' |translate}}
          </div>
          }
        </div>
      </div>
      } @if (serviceName == 'ATA_CARNET' && allProducts && allProducts.length > 0) {
      <h3 class="text-base font-semibold text-dc-orange" [innerHTML]="'PRODUCT_LIST.TOTAL_INVOICE_VALUE'
            | translate : { total: totalUnitPrice | number:'1.2-2' }">
      </h3>
      }
    </div>
    }

    <div class="buttons-group fields-container">
      @if ((allProducts && allProducts.length > 0) || form.get('mode')?.value == 'manual') {
         @if(mode != 'view') {
          <app-button
            classesName="card-edge-cut-white btn-width-auto"
            [label]="'BUTTONS.SAVE_CLOSE' | translate"
            (onBtnClick)="saveClose()"
          ></app-button>      
         }
         @if(mode == 'view') {
          <app-button
            classesName="card-edge-cut-white btn-width-auto"
            [label]="'BUTTONS.CLOSE' | translate"
            (onBtnClick)="close()"
          ></app-button>
         }
      }
    </div>
  </form>
</div>
